import { ReactComponent as IconCheckmarkSimilarityGreen } from '../../public/images/svg/icon_checkmark_similarity_green.svg';
import { ReactComponent as IconCheckmarkSimilarityRed } from '../../public/images/svg/icon_checkmark_similarity_red.svg';
import { ReactComponent as IconCheckmarkSimilarityYellow } from '../../public/images/svg/icon_checkmark_similarity_yellow.svg';

export const SIMILARITY = {
  Green: {
    icon: <IconCheckmarkSimilarityGreen />,
    bgColor: 'bg-green-100',
    contentTitle: (example) => `Generated text is not considered to be copied from the ${example}`
  },
  Amber: {
    icon: <IconCheckmarkSimilarityYellow />,
    bgColor: 'bg-yellow-100',
    contentTitle: (example) => `Generated text is considered to be close to the ${example}`
  },
  Red: {
    icon: <IconCheckmarkSimilarityRed />,
    bgColor: 'bg-red-200',
    contentTitle: (example) => `Generated text is considered to be copied from the ${example}`
  }
};
